import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';
export const getPartner = async (partnerCode, ssoToken) => {
  const apiURL =
    API_HOST + '/partners/load?partner_code=' + partnerCode + (ssoToken ? '&partner_user=' + ssoToken : '');

  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    // console.log('here is the data in getPartner: ', data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
